export const navigation = [
  { name: '주문 목록', href: '/admin/orders' },
  { name: '상품 등록', href: '/admin/products' },
  { name: '상품 목록', href: '/admin/products-list' },
  { name: '교환/반품', href: '/admin/exchange-return' },
  { name: '견적문의 목록', href: '/admin/inquire-list' },
  { name: 'QnA 관리', href: '/admin/qna' },
  { name: '리뷰 관리', href: '/admin/review' },
  { name: '회원 관리', href: '/admin/user-management' },
  { name: '공지 등록', href: '/admin/notice' },
  { name: '공지 목록', href: '/admin/notice-list' },
];
